import {z} from 'zod';

export const SupplierOrderFormSchema = z.object({
  warehouseId: z.string(),
  orderVariantId: z.string(),
  supplierId: z.string(),
  type: z.string().nullish(),
  supplierAccountCode: z.string().nullish(),
  currency: z.string().nullish(),
  exchangeRate: z.number().min(0).nullish(),
  ncConversion: z.string().nullish(),
  note: z.string().nullish(),
});

export type SupplierOrderForm = z.infer<typeof SupplierOrderFormSchema>;
